module.exports = __webpack_public_path__ + "img/12.7e9bea4c.jpg";